// extracted by mini-css-extract-plugin
export default {"editComment":"EditComment_editComment__p4vFl"};